import { useState } from 'react';
import { FaPlay, FaRegClock } from 'react-icons/fa6';

/* 16:9 thumbnail with optional duration badge (top-left) and a slot (children)
   for extra overlays like the Shorts pill.
   Renders the real `thumbnail` image when given, falling back to the `grad`
   gradient placeholder when it's missing or fails to load (e.g. mock data).
   When `onPlay` is provided the play overlay becomes a real button. */
export default function Thumb({ grad = ['#2b3146', '#171b29'], dur, ratio = '16/9', radius = 12, thumbnail, onPlay, children }) {
	const [imgOk, setImgOk] = useState(true);
	const showImg = thumbnail && imgOk;
	return (
		<div
			className="relative overflow-hidden"
			style={{ aspectRatio: ratio, borderRadius: radius, background: `linear-gradient(135deg, ${grad[0]}, ${grad[1]})` }}
		>
			{showImg ? (
				<img
					src={thumbnail}
					alt=""
					loading="lazy"
					onError={() => setImgOk(false)}
					className="absolute inset-0 w-full h-full object-cover"
				/>
			) : (
				<div
					className="absolute inset-0 opacity-[0.16]"
					style={{ backgroundImage: 'repeating-linear-gradient(135deg,#fff 0 2px,transparent 2px 11px)' }}
				/>
			)}
			<div className="absolute inset-0 grid place-items-center text-white/90">
				{onPlay ? (
					<button
						type="button"
						onClick={onPlay}
						aria-label="Play video"
						className="w-11 h-11 rounded-full bg-black/30 grid place-items-center backdrop-blur-[2px] transition hover:bg-black/50 hover:scale-110 cursor-pointer"
					>
						<FaPlay size={16} />
					</button>
				) : (
					<div className="w-11 h-11 rounded-full bg-black/30 grid place-items-center backdrop-blur-[2px]">
						<FaPlay size={16} />
					</div>
				)}
			</div>
			{dur && (
				<div className="absolute top-2 left-2">
					<span className="inline-flex items-center gap-1 bg-white/90 text-slate-800 text-[11px] font-semibold px-2 py-[3px] rounded-full backdrop-blur shadow-[0_1px_6px_rgba(0,0,0,0.45)] ring-1 ring-black/5">
						<FaRegClock size={10} />{dur}
					</span>
				</div>
			)}
			{children}
		</div>
	);
}
